<template>
  <div class="market-qualification">
    <el-main class="list-container">
      <el-table id="list-container-tableElement" v-bind:data="tableData" style="width: 100%">
        <!-- BasicText column -->
        <el-table-column v-for="( item , index ) in titles" :key="index" v-bind:prop="item.prop" v-bind:label="item.label">
          <template slot-scope="scope">
            <p> {{ modifyData(scope.row,item.prop) }} </p>
          </template>
        </el-table-column>
        <!-- Subtotal column -->
        <el-table-column label="%" v-bind:width="subtotalWidth">
          <template slot-scope="scope">
             <!-- <p> {{ scope.row.color }} </p> -->
            <percentageBar class="percentage-bar" ref="percentageBar" v-bind:second-color="scope.row.color" v-bind:data="scope.row.percentage">
            </percentageBar>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </div>
</template>

<script>
/* Imports are written here */
import percentageBar from "./PercentageBar";
export default {
  components: {
    percentageBar: percentageBar
  },
  props: {
    graph_data: Object
  },
  data() {
    return {
      subtotalWidth: Number,
      titles: [],
      colore: "red",
    };
  },
  computed: {},
  watch: {
    graph_data: "updateComponent"
  },
  methods: {
    manageColor(value){
        return value
    },
    modifyData(object, keyValue) {
      let value = object[keyValue];
      if (keyValue == "price" || keyValue == "amount") {
        value = "$" + value.toLocaleString();
      } else if (keyValue.includes("rtoAcom") || keyValue == "comisiones") {
        value = value * 1000 / 10;
        if (value % 1 != 0) {
          let num = value;
          num = num.toFixed(2);
          value = Number(num);
          value = "%" + value;
        }
      }
      return value;
    },
    updateComponent() {
      this.tableData = this.graph_data.data;
      this.titles = this.graph_data.titles;
      this.subtotalWidth = 500;
    }
  },
  beforeMount() {
    this.updateComponent();
  },
  mounted() {}
};
</script>

<style lang="css">
.market-qualification .el-table th > .cell {
  text-align: left;
}
.market-qualification {
  display: block;
  margin: 0 auto;
  max-width: 720px;
  margin-bottom: 2em;
  margin-top: 2em;
}
.market-qualification .cell {
  line-height: 14px;
  font-size: 12px;
  word-break: break-word;
}
.market-qualification .has-gutter {
  color: #001f5c !important;
}
</style>

<style lang="css" scoped>
.el-main {
  text-align: left;
  line-height: 14px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/marketGrade.vue